import axiosInstance from './axiosConfig';
import { SecuritySettings, SecuritySettingsUpdate } from '../types/security';

export const securitySettingsService = {
  // Get current security settings
  async getSecuritySettings(): Promise<SecuritySettings> {
    try {
      const response = await axiosInstance.get('/security-settings');
      return response.data;
    } catch (error) {
      // Return default settings if API fails
      return {
        token_check_interval: 5,
        inactivity_timeout: 60,
        session_duration: 8,
        security_notifications: true,
        force_logout_enabled: false
      };
    }
  },

  // Update security settings
  async updateSecuritySettings(settings: SecuritySettingsUpdate): Promise<SecuritySettings> {
    const response = await axiosInstance.put('/security-settings', settings);
    return response.data;
  },

  // Force logout all users
  async forceLogoutAllUsers(): Promise<void> {
    await axiosInstance.post('/security-settings/force-logout');
  },

  // Get available options for dropdowns
  getTokenCheckIntervals() {
    return [
      { value: 1, label: '1 minute' },
      { value: 2, label: '2 minutes' },
      { value: 5, label: '5 minutes' },
      { value: 10, label: '10 minutes' },
      { value: 15, label: '15 minutes' },
      { value: 30, label: '30 minutes' }
    ];
  },

  getInactivityTimeouts() {
    return [
      { value: 15, label: '15 minutes' },
      { value: 30, label: '30 minutes' },
      { value: 60, label: '1 hour' },
      { value: 120, label: '2 hours' },
      { value: 240, label: '4 hours' }
    ];
  },

  getSessionDurations() {
    return [
      { value: 4, label: '4 hours' },
      { value: 8, label: '8 hours' },
      { value: 12, label: '12 hours' },
      { value: 24, label: '24 hours' }
    ];
  }
}; 